// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/Users/yunfei/workspace-lotto-cms/lotto-cms-bo/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: '@@initialState', model: model_1 },
} as const
